import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { trackClairtyEvent } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import { Line } from '../action/Line';
import LoginButton from '../login/LoginButton';
import ThemedText from '../theme/ThemedText';
import './Sidebar.scss';
const headings = [
  {
    text: 'Your Feed',
    route: '/takes/feed',
    isProtected: false,
  },
  {
    text: 'X Takes',
    route: '/takes/twitterTakes',
    isProtected: false,
  },
  {
    text: 'Profiles',
    route: '/profiles',
    isProtected: true,
  },
  {
    text: 'Invite',
    route: '/invite',
    isProtected: true,
  },
];

const Sidebar = () => {
  const { width } = useWindowSize();
  const location = useLocation();
  const navigate = useNavigate();

  const { openLogin, userLogout } = useLoginHelper();

  const [{ user }] = useGlobalState();

  function isActive(route) {
    return location.pathname.includes(route);
  }

  function handleRoute(route, isProtected) {
    if (isProtected && !user?.address) {
      return openLogin();
    }
    trackClairtyEvent('page_visited', {
      page: route,
      user_state: user ? 'logged_in' : 'logged_out',
    });
    navigate(route);
  }

  // if (width <= 600) {
  //   return (
  //     <Flexbox className='lowerbar_container' justifyContent='space-evenly'>
  //       {headings.map((item, _idx) => (
  //         <ThemedText.H6
  //           className={isActive(item?.route) ? 'active' : 'non-active'}
  //           weight={isActive(item?.route) ? 'semi-bold' : 'normal'}
  //           onClick={() => handleRoute(item?.route, item?.isProtected)}
  //         >
  //           {item?.text}
  //         </ThemedText.H6>
  //       ))}
  //     </Flexbox>
  //   );
  // }
  return (
    <div className='sidebar_container'>
      <FlexboxColumn justifyContent='flex-start' alignItems='flex-start' gap='1.5rem' className='sidebar_container_items'>
        {headings.map((item, _idx) => (
          <ThemedText.H6
            className={isActive(item?.route) ? 'active' : 'non-active'}
            weight={isActive(item?.route) ? 'semi-bold' : 'normal'}
            onClick={() => handleRoute(item?.route, item?.isProtected)}
          >
            {item?.text}
          </ThemedText.H6>
        ))}
      </FlexboxColumn>
      <FlexboxColumn justifyContent='flex-start' alignItems='flex-start' gap='1.5rem'>
        {user && (
          <>
            <Flexbox fw gap='0'>
              <Flexbox className='UserDropdown-container navbar_login_button' onClick={() => handleRoute(`/profile/${user?.address}/projects`, true)}>
                <img src={user?.avatarUrl} alt='user_image' />
                {width <= 600 ? (
                  <></>
                ) : (
                  <ThemedText.H6 weight='semi-bold' className={isActive(`/profile/${user?.address}/projects`) ? 'active' : 'non-active'}>
                    {user?.name}
                  </ThemedText.H6>
                )}
              </Flexbox>
              <Line />
            </Flexbox>

            <Flexbox className='sidebar_container_items'>
              <ThemedText.H6
                className={isActive('/settings') ? 'active' : 'non-active'}
                weight={isActive('/settings') ? 'semi-bold' : 'normal'}
                onClick={() => handleRoute('/settings', true)}
              >
                Settings
              </ThemedText.H6>
            </Flexbox>
          </>
        )}
        {user ? (
          <Flexbox className='sidebar_container_items'>
            <ThemedText.H6 className={isActive('/logout') ? 'active' : 'non-active'} onClick={userLogout}>
              Logout
            </ThemedText.H6>
          </Flexbox>
        ) : (
          <LoginButton />
        )}
      </FlexboxColumn>
    </div>
  );
};

export default Sidebar;
